import { DeviceEnrollmentOptions } from '@xemplo/gp-types';
import { RadioOption } from '@xemplo/radio-button';

export const BasicDetailsSectionTestId = {
  Fieldset: 'basic-details-fieldset',
  Legend: 'basic-details-legend',
};

export const EnrollmentOptsMfaEnabled: RadioOption[] = [
  { label: 'Disabled', value: DeviceEnrollmentOptions.Disabled },
  { label: 'Optional', value: DeviceEnrollmentOptions.Optional },
];

export const EnrollmentOptsMfaDisabled: RadioOption[] = [
  ...EnrollmentOptsMfaEnabled,
  { label: 'Mandatory', value: DeviceEnrollmentOptions.Mandatory },
];
